<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-5 col-sm-8">
          <h5>Class Exam Grades</h5>
        </div>
        <div class="col-7 col-sm-4 text-right">
          <button
            type="button"
            class="btn btn-primary btn-with-addon"
            @click="showGradeAssignForm(null)"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-plus-circle" />
            </span>
            Assign Exam Grade
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <class-exam-grade-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <assign-class-exam-grade @created="handleCreated"/>
  </div>
</template>

<script>
import ClassExamGradeTable from '@/components/exam/classgrades/Table/index'
import AssignClassExamGrade from '@/components/exam/classgrades/Forms/Assign/index'

export default {
  components: {
    ClassExamGradeTable,
    AssignClassExamGrade,
  },
  mounted: function() {
    this.getClassExamGrades()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    showGradeAssignForm(classGradeId) {
      this.$eventBus.$emit('openGradeAssignFormModal', classGradeId)
    },
    getClassExamGrades: function() {
      this.loading = true
      this.$http.get('/api/assign_grade_class', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getClassExamGrades()
    },
    handleUpdateTable: function() {
      this.getClassExamGrades()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getClassExamGrades()
    },
    onChange(current) {
      this.current = current
      this.getClassExamGrades()
    },
  },
}
</script>
